import { LoggedInStatus } from './logged-in-status';

type customerTypes =
  | 'all'
  | 'postpaid'
  | 'prepaid'
  | 'prepaidOnly'
  | 'postpaidOnly'
  | 'postpaidVoice'
  | 'noPostpaidVoice';

export interface RedirectResponse {
  redirect_url: string;
  logged_in_status: string;
  customer_type: string;
}

export class Redirect extends LoggedInStatus {
  redirectUrl: string;
  customerType: customerTypes;

  constructor(data: RedirectResponse) {
    super(data.logged_in_status);
    this.redirectUrl = data.redirect_url;
    this.customerType = this.mapCustomerType(data.customer_type);
  }

  mapCustomerType(value: string): customerTypes {
    return <customerTypes>{
      All: 'all',
      'Has prepaid': 'prepaid',
      'Has postpaid': 'postpaid',
      'Has only prepaid': 'prepaidOnly',
      'Has only postpaid': 'postpaidOnly',
      'Has postpaid voice': 'postpaidVoice',
      'Has no postpaid voice': 'noPostpaidVoice',
    }[value];
  }
}
